import type { SubscriptionPlan } from './Subscriptions';

/** Matches worker / mobile Stripe products (metadata.sku). */
export type SubscriptionSku = 'basic' | 'premium' | 'ultra' | 'enterprise';

/**
 * Stripe Price IDs (same as skimbuster-mobile src/utility/constant.tsx STRIPE_PRICE_IDS).
 */
export const STRIPE_PRICE_IDS: Partial<Record<SubscriptionSku, { month?: string; year?: string }>> = {
  basic: { month: 'price_1TAxUfCkQ4xgbCDC59kLxVGw', year: 'price_1TAxUfCkQ4xgbCDC54dXzX2b' },
  premium: { month: 'price_1TAxUfCkQ4xgbCDCft1kU9TM', year: 'price_1TAxUgCkQ4xgbCDCkycEilNA' },
  ultra: { month: 'price_1TAxUgCkQ4xgbCDCKRV5m8jD', year: 'price_1TAxUgCkQ4xgbCDCjug8zIRc' },
  enterprise: {},
};

export function planIdToWorkerSku(planId: string): SubscriptionSku {
  const lower = planId.toLowerCase();
  if (lower.includes('enterprise')) return 'enterprise';
  if (lower.includes('ultra')) return 'ultra';
  if (lower.includes('premium')) return 'premium';
  if (lower.includes('basic')) return 'basic';
  return 'basic';
}

export function planCategoryToWorkerCategory(
  category: SubscriptionPlan['category']
): 'corporate' | 'law' {
  return category === 'law-enforcement' ? 'law' : 'corporate';
}

export function getPriceIdForPlan(plan: SubscriptionPlan, isAnnual: boolean): string | undefined {
  const sku = planIdToWorkerSku(plan.id);
  const row = STRIPE_PRICE_IDS[sku];
  if (!row) return undefined;
  return isAnnual ? row.year : row.month;
}

export function getPortalBillingUrls(): { successUrl: string; cancelUrl: string; portalReturnUrl: string } {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return {
    successUrl: `${origin}/subscription/success`,
    cancelUrl: `${origin}/subscription/cancel`,
    portalReturnUrl: `${origin}/settings`,
  };
}

/**
 * Checkout return URLs for registration. Include Stripe's session placeholder so the success page
 * receives `session_id` for finalize/sign-in after payment (worker must pass this URL to Checkout).
 */
export function getRegistrationCheckoutUrls(): { successUrl: string; cancelUrl: string } {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return {
    successUrl: `${origin}/subscription/success?from=register&session_id={CHECKOUT_SESSION_ID}`,
    cancelUrl: `${origin}/subscription/cancel?from=register`,
  };
}
